// extracted by mini-css-extract-plugin
export var main = "bw_fb";
export var target = "bw_d9";